import React from "react";
import { toIndianRs } from "../../../../../utils/helpers";
import { giftSvg } from "../../../../DealsAndDiscounts/Components/Header/svg";
import { isRewardsVisible } from "../../../../../utils/routing";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var FifthStep = function FifthStep(_ref) {
  var userAccountSummary = _ref.userAccountSummary,
    getUserAccountSummary = _ref.getUserAccountSummary,
    setStep = _ref.setStep,
    setOpenKYCModal = _ref.setOpenKYCModal,
    closeKYCModal = _ref.closeKYCModal,
    initiateWorkflow = _ref.initiateWorkflow,
    bankstatus = _ref.bankstatus;
  var outstandingAmount = userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission;
  var tdsAmount = outstandingAmount * 0.1;
  var totalAmount = outstandingAmount - tdsAmount;
  var handleClick = function handleClick() {
    if (bankstatus === "COMPLETED") {
      setStep(3);
    } else {
      initiateWorkflow("BANK_ACCOUNT_VERIFICATION");
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex  flex-col items-center justify-center px-4 pt-6 pb-4 md:px-10 md:pt-6 md:pb-4",
      children: [/*#__PURE__*/_jsxs("div", {
        className: " border border-black w-64 md:w-96 lg:w-full",
        children: [/*#__PURE__*/_jsx("div", {
          className: " text-center font-bold py-2 border-b border-black text-base lg:text-lg",
          children: "Transfer to Bank Account"
        }), /*#__PURE__*/_jsxs("div", {
          className: "p-4 text-sm lg:text-base",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex justify-between py-1 font-semibold",
            children: [/*#__PURE__*/_jsx("span", {
              children: "Referral Amount"
            }), /*#__PURE__*/_jsx("span", {
              children: toIndianRs(outstandingAmount)
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between py-2 font-semibold",
            children: [/*#__PURE__*/_jsx("span", {
              children: "TDS @ 10%"
            }), /*#__PURE__*/_jsx("span", {
              children: toIndianRs(tdsAmount)
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between border-t border-gray-100 py-1 mt-2 font-bold",
            children: [/*#__PURE__*/_jsx("span", {
              children: "TOTAL"
            }), /*#__PURE__*/_jsx("span", {
              children: toIndianRs(totalAmount)
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "flex items-start justify-start",
        children: /*#__PURE__*/_jsx("p", {
          className: "text-sm text-gray-500 ml-2 lg:-ml-2 mt-2 ",
          children: "*TDS calculations are indicative as per Section 194J of the Income Tax Act."
        })
      }), /*#__PURE__*/_jsx("div", {
        className: " pt-3 pb-2 lg:pt-3  lg:pb-3 xl:pt-4 xl:pb-4",
        children: /*#__PURE__*/_jsx("button", {
          onClick: handleClick,
          className: "bg-primary text-white rounded-md font-bold px-10  md:px-14 py-2 lg:py-3",
          children: "Continue"
        })
      }), isRewardsVisible && /*#__PURE__*/_jsxs("div", {
        onClick: closeKYCModal,
        className: "flex border-2 rounded-xl mt-4 cursor-pointer w-64 md:w-96 lg:w-full py-4 px-3 lg:px-4",
        children: [giftSvg, /*#__PURE__*/_jsxs("div", {
          className: "ml-2",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "font-semibold",
            children: "Want to claim the whole amount?"
          }), /*#__PURE__*/_jsx("p", {
            className: "text-sm",
            children: "Redeem your reward at our exclusive store"
          })]
        })]
      })]
    })
  });
};
export default FifthStep;